import React, { useState } from 'react';
import styles from '../../styles/Users.module.css';

//let data: any;
const Users = (props) => {

  //searchBAR
  const [search, setSearch] = useState('');

  let users = props.data

  let filteredUsers = null;
  if (users) {
    filteredUsers = users.filter(eachUser => {
      return eachUser.name.toLowerCase().indexOf(search) !== -1;
    })
  }
  
  let allUsers = null;
  if (filteredUsers) {
    allUsers = (
      filteredUsers.map((each, index) => (
        <div
          className={styles.EachUser}
          key={each.id}
          onClick={() => props.userClick(each.id, index, each.name)}>
          <img className={styles.UserIcon} src={require('../../icons/user.png')} alt="Users icon" />
            <p> {each.name}</p>  
        </div>
      )) 
    )  
  }

  return  (
    <div className={styles.Users}>
      <div className={styles.UsersInput}>
        <input
          type='text'
          placeholder='Išči...'
          //value={search} // DONT NEED THIS
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className={styles.UsersName}>
        <img className={styles.UsersIcon} src={require('../../icons/users.png')} alt="Users icon" />
        <h3>Uporabniki</h3>
      </div>
      
      {allUsers}
    </div>
  ) 
}

export default Users;
